module.exports = __webpack_public_path__ + "media/packs/images/flags/ET-78169a2a2f4e58b91abb344425f9c3d8.png";